import PlanificadorFormularioService from 'src/modules/planificadorFormulario/planificadorFormularioService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PLANIFICADORFORMULARIO_VIEW';

const planificadorFormularioViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorFormularioViewActions.FIND_STARTED,
      });

      const record = await PlanificadorFormularioService.find(id);

      dispatch({
        type: planificadorFormularioViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorFormularioViewActions.FIND_ERROR,
      });

      getHistory().push('/planificador-formulario');
    }
  },
};

export default planificadorFormularioViewActions;
